import store from "../store";

let getMaxH = function () {
  store.commit("setMaxH", document.documentElement.clientHeight);
  window.onresize = function () {
    store.commit("setMaxH", document.documentElement.clientHeight);
  };
};
export default getMaxH;
